module.exports = __webpack_public_path__ + "img/img2.25403b13.png";